import React, { createContext, useContext, useMemo, useState } from 'react';

import type { PersonalStats } from 'src/components/pages/Result/utils';

export type AppContextValue = {
  personalStats: PersonalStats | null;
  setPersonalStats: (stats: PersonalStats) => void;
};

const Context = createContext<AppContextValue | null>(null);

type AppContextProps = {
  children: React.ReactNode;
  initialPersonalStats?: PersonalStats | null;
};

export const AppContext = ({ children, initialPersonalStats = null }: AppContextProps) => {
  const [personalStats, setPersonalStats] = useState<PersonalStats | null>(initialPersonalStats);

  const value = useMemo(() => {
    return {
      personalStats,
      setPersonalStats: (stats: PersonalStats | null) => {
        if (stats?.birthDate === personalStats?.birthDate) {
          return;
        }

        setPersonalStats(stats);
      },
    };
  }, [personalStats]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useAppContext = () => {
  const value = useContext(Context);

  if (!value) {
    throw new Error('useAppContext must be used within AppContext');
  }

  return value;
};
